export default "__VITE_ASSET__BBfjAjh3__"